import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { RootState } from "StoreTypes";
import React, { useCallback } from "react";
import { AxiosRequestConfig } from "axios";
import { SearchContext, SearchProps } from "../contexts/search/SearchContext";
import { getMismatchedTrades, getMisbilledTrades } from "../../actions";
import { useToastErrorHandler } from "../../hooks";

interface Props extends PropsFromRedux {
  children: JSX.Element | JSX.Element[];
}

const SearchProviderComponent = ({
  mismatchedRecordState,
  misbilledRecordState,
  children,
  getMismatchedTrades,
  getMisbilledTrades,
}: Props) => {
  const onError = useToastErrorHandler();
  const searchStateAndActions: SearchProps = {
    mismatchedRecordState,
    misbilledRecordState,
    getMismatchedTrades: useCallback(
      () => getMismatchedTrades(onError),
      [getMismatchedTrades]
    ),
    getMisbilledTrades: useCallback(
      (startDate: string, endDate: string, config: AxiosRequestConfig) =>
        getMisbilledTrades(startDate, endDate, config, onError),
      [getMisbilledTrades]
    ),
  };

  return (
    <SearchContext.Provider value={searchStateAndActions}>
      {children}
    </SearchContext.Provider>
  );
};

const mapStateToProps = ({
  mismatchedTradesReducer: mismatchedRecordState,
  misbilledTradesReducer: misbilledRecordState,
}: RootState) => ({
  mismatchedRecordState,
  misbilledRecordState,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getMismatchedTrades: (onError: (error: string) => void) =>
    getMismatchedTrades(dispatch, onError),
  getMisbilledTrades: (
    startDate: string,
    endDate: string,
    config: AxiosRequestConfig,
    onError: (error: string) => void
  ) => getMisbilledTrades(dispatch, startDate, endDate, config, onError),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export const SearchProvider = connector(SearchProviderComponent);
